<template>
  <Dropdown
    :triggers="isDesktop ? ['hover'] : ['click']"
    :placement="placement"
    :distance="distance"
    :auto-hide="true"
    :positioning-disabled="!isDesktop"
    :style="markerPosition"
    class="marker absolute z-[9] rounded-full"
  >
    <div
      class="h-[2rem] w-[2rem] cursor-pointer before:absolute before:inset-0 before:m-auto before:block before:h-[0.75rem] before:w-[0.75rem] before:rounded-full before:bg-white md:h-[1.875rem] md:w-[1.875rem] md:before:h-4 md:before:w-4 lg:h-10 lg:w-10"
    ></div>

    <template #popper>
      <slot name="popper"></slot>

      <div
        v-if="marker.title || marker.text"
        class="rounded-md bg-white text-slate shadow-[0_4px_24px__rgba(0,0,0,0.16)] md:w-[260px]"
      >
        <div class="p-6">
          <div class="text-bold title mb-1 text-[0.875rem] uppercase">
            {{ marker.title }}
          </div>

          <div class="text-[0.75rem]">
            {{ marker.text }}
          </div>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Dropdown, type Placement } from 'floating-vue';
import { useBreakpoint } from '~/composables';

interface Props {
  marker?: any;
  distance?: string | number;
  placement?: Placement;
}
const props = withDefaults(defineProps<Props>(), {
  marker: () => ({}),
  distance: 16,
  placement: 'left',
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

// @TODO: Simplify after deploying to master and changing json format of block at homepage
const markerPosition = computed(() =>
  !props.marker.position.desktop
    ? props.marker.position
    : (!isDesktop.value && props.marker.position.mobile) ||
      props.marker.position.desktop,
);
</script>

<style lang="sass" scoped>
.marker
  background: linear-gradient(180deg, rgba(126, 126, 126, 0.24) 0%, rgba(187, 187, 187, 0.16) 100%)
  backdrop-filter: blur(10px)

  &::before
    transform: translate(-50%, -50%)
    filter: drop-shadow(0px 4px 24px rgba(0, 0, 0, 0.16))
</style>
